import { iUserData } from '@/entities/user/user.types';
import { FormLike, ToastyLike } from '@/ui/types/components.types';
import UserData from '@/entities/user/user-data';
import serviceProvider from '@/services/service-provider';
import useI18n from '@/ui/composables/base/use-i18n';
import useAsyncValidation from '@/ui/composables/base/use-async-validation';
import { I18nType } from '@/ui/types/i18n.types';
import { ObjectLike } from '@/types/objectlike.types';

const MODULE = 'Signup';

export default function (vm: any, i18n: I18nType, $refs: any, signupVariables: ObjectLike) {
  const {
    username,
    gamertag,
    password,
    email,
    loading,
    errorMessage,
    usernameError,
  } = signupVariables;

  const asyncValidation = useAsyncValidation(i18n);

  async function signUp() {
    const user: iUserData = new UserData(
      username.value,
      gamertag.value,
      email.value,
      password.value,
    );

    return serviceProvider.auth.register(user);
  }

  async function validateUsername() {
    usernameError.value = '';

    const message = await asyncValidation({
      module: MODULE,
      submodule: 'errors',
      property: 'usernameAlreadyExists',
    }, serviceProvider.user.usernameIsValid.bind(serviceProvider.user), username.value);

    if (typeof message === 'string') {
      usernameError.value = message;
      return false;
    }

    return true;
  }

  function handleError(error: any) {
    const { getText } = useI18n(vm);
    const toasty = $refs.toasty as Vue & ToastyLike;
    const SUBMODULE = 'errors';
    const DEFAULT_ERROR = 'general';

    errorMessage.value = getText(MODULE, SUBMODULE, DEFAULT_ERROR);

    if (error.code === 'auth/email-already-in-use') {
      errorMessage.value = getText(MODULE, SUBMODULE, 'emailAlreadyExists');
    }

    toasty.show();
  }

  async function submit() {
    if (!vm) return;

    loading.value = true;

    // This is a hack to let typescript know that child has validate method
    const form = $refs.form as Vue & FormLike;
    form.validate();
    const isUsernameValid = await validateUsername();

    const { valid } = form;

    if (!valid || !isUsernameValid) {
      loading.value = false;
      return;
    }

    try {
      await signUp();
      vm.$router.replace({ name: 'Login' });
    } catch (error) {
      console.error(error);
      handleError(error);
    } finally {
      loading.value = false;
    }
  }

  function goToLandingPage() {
    vm.$router.replace({ name: 'LandingPage' });
  }

  return {
    signUp,
    submit,
    validateUsername,
    goToLandingPage,
  };
}
